import sideBar from '../sidebar';

const tour = () =>
    [{
        element: '#btn-reload',
        title: 'Bem vindo ao NeoGIG',
        content: 'O NeoGIG é uma ferramenta de apoio à decisão para executivos de vendas e marketing. Este tour irá guiá-lo ao longo do site! Basta avançar para o próximo passo.',
        placement: 'bottom',
        onShow () {
            return sideBar.close();
        }
    }];

export default tour;



// WEBPACK FOOTER //
// ./src/scripts/core/tour/start.js